import {
  GET_COMMENT,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
} from "../../shared/constants/ActionTypes";

const initialComment = {
  comment: [],
  commentCount: 0,
  page: 1,
  search: "",
  courseId: "",
};

const postReducer = (state = initialComment, action) => {
  switch (action.type) {
    case GET_COMMENT:
      return {
        ...state,
        comment: action.payload?.comment?.map((item) => {
          return {
            ...item,
            message: item?.comments?.message,
          };
        }),
        commentCount: action.payload?.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };

    default:
      return state;
  }
};

export default postReducer;
